export const handleChangeInput = (cb: Function) => (value: string) => {
    cb(value);
};

export const handleSubmitForm = (cb: Function) => (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    cb();
};

export function validateInput(valueMaxLength: number, value: string) {
    const valueParsed = parseInt(value, 10);
    return typeof valueParsed === 'number' && value.length <= valueMaxLength;
}

export function returnInputNumber(value: string) {
    const regexp = /^\d+$/;
    return `${regexp.test(value) ? value : value.slice(0, -1)}`;
}

export const isValidUrl = (url: string): boolean => {
    const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (regexp.test(url)) {
        return true;
    } else {
        return false;
    }
};
